module.exports = __webpack_public_path__ + "static/media/icon_unique-data.3d9f46ac.svg";